import React, { Suspense, lazy } from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import LoadingHold from "components/LoadingHold.js";

import "./App.css";

const SetPassword = lazy(() => import("components/SetPassword"));
const ResetPassword = lazy(() => import("components/ResetPassword"));

function App() {
  return (
    <Router>
      <Switch>
      <Route
          path="/resetPassword"
          render={(renderProps) => {
            return (
              <Suspense fallback={<LoadingHold />}>
                <ResetPassword {...renderProps} />
              </Suspense>
            );
          }}
        />
        <Route
          path="/:key"
          render={(renderProps) => {
            return (
              <Suspense fallback={<LoadingHold />}>
                <SetPassword {...renderProps} />
              </Suspense>
            );
          }}
        />
        <Route
          path="*"
          render={() => {
            return (
              <div style={{ textAlign: "center", marginTop: 10 }}>
                该链接无效
              </div>
            );
          }}
        />
      </Switch>
    </Router>
  );
}

export default App;
